import { Note } from "../systems/Helpers/Note";

export const areShallowEqualFull = (
  componentName: string = "component",
  ignoredKeys: string[] = [],
  extraCheck: ((a: any, b: any) => boolean) | undefined = undefined,
  loud: boolean = false,
) =>
  (prevProps: any, nextProps: any) => {
    const nextPropsKeys = Object.keys(nextProps);
    const prevPropsKeys = Object.keys(prevProps);
    if (nextPropsKeys.length !== prevPropsKeys.length) {
      loud && Note.quick(`${componentName} props length changed`, {
        nextPropsKeys,
        prevPropsKeys,
      });
      return false;
    }
    for (let i = 0; i < nextPropsKeys.length; i++) {
      const key = nextPropsKeys[i];
      if (
        nextProps[key] !== prevProps[key] && ignoredKeys.indexOf(key) === -1
      ) {
        loud && Note.quick(`${componentName} prop changed`, {
          key,
          nextProps,
          prevProps,
        });
        return false;
      }
    }
    if (extraCheck) {
      if (!extraCheck(nextProps, prevProps)) {
        loud && Note.quick(`${componentName} extra check failed`, {
          nextProps,
          prevProps,
        });
        return false;
      }
    }
    return true;
  };

export const areShallowEqual = areShallowEqualFull();